export const columnsCompany = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '标题',
    dataIndex: 'name',
  },
  {
    title: '作者',
    dataIndex: 'admin_name',
  },
  {
    title: '缩略图',
    dataIndex: 'thumbnail',
    scopedSlots: { customRender: 'thumbnail' },
    width: 100,
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
  },
  {
    title: '发布时间',
    dataIndex: 'create_time',
  },
  {
    title: '文章详情',
    dataIndex: 'jump_url',
    scopedSlots: { customRender: 'jump_url' },
  },
  {
    title: '关联产品',
    dataIndex: 'product_info_title',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const columnsService = [
  {
    title: '序号',
    dataIndex: 'id',
    width: '60px'
  },
  {
    title: '资讯类型',
    dataIndex: 'type',
    width: '100px',
	  scopedSlots: { customRender: 'type' },
  },
  {
    title: '资讯标题',
    dataIndex: 'name',
  },
  {
    title: '缩略图',
    dataIndex: 'thumbnail',
    scopedSlots: { customRender: 'thumbnail' },
    width: '80px',
  },
  {
    title: '浏览量',
    dataIndex: 'hits',
    width: '85px'
  },
  {
    title: '发布时间',
    dataIndex: 'create_time',
    width: '180px',
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
    width: '180px',
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: '85px',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '120px',
    scopedSlots: { customRender: 'operation' },
  },
];


export const formDataCompany = [
  // {
  //   name: 'group_id',
  //   lable: '选择栏目',
  //   lableCol: 3,
  //   wrapperCol: 18,
  // },
 {
 	  name: 'product_id',
 	  lable: '关联产品',
 	  lableCol: 3,
 	  wrapperCol: 18,
  },
  {
    name: 'name',
    lable: '标题',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'post_excerpt',
    lable: '摘要',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'post_content',
    lable: '内容',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'thumbnail',
    lable: '缩略图',
    lableCol: 3,
    wrapperCol: 18,
  },
];
export const formDataService = [
  // {
  //   name: 'company_id',
  //   lable: '选择企业',
  //   lableCol: 3,
  //   wrapperCol: 18,
  // },
  // {
  //   name: 'group_id',
  //   lable: '选择栏目',
  //   lableCol: 3,
  //   wrapperCol: 18,
  // },
  // {
  // 	  name: 'product_id',
  // 	  lable: '关联产品',
  // 	 lableCol: 3,
  // 	 wrapperCol: 18,
  //  },
  {
    name: 'status',
    lable: '显示状态',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'is_top',
    lable: '置顶',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'type',
    lable: '资讯类型',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'name',
    lable: '标题',
    lableCol: 3,
    wrapperCol: 18,
  },
  // {
  //   name: 'post_excerpt',
  //   lable: '摘要',
  //   lableCol: 3,
  //   wrapperCol: 18,
  // },
  {
    name: 'post_content',
    lable: '内容',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
   name: 'thumbnail',
   lable: '缩略图',
   lableCol: 3,
   wrapperCol: 18,
  },
];